export default function (state,getters) {
    let form = getters.data;
    let url = '';
    for (let k in form) {
        switch (k){
            case 'CreateDateFrom':
            case 'CreateDateTo':
            case 'PaymentDateFrom':
            case 'PaymentDateTo':
            case 'ChangeDateFrom':
            case 'DateStatement':
            case 'ChangeDateTo':
                url += '&' + encodeURIComponent('parameters[' + k + '.Serialized]') + '=' + encodeURIComponent(form[k].Serialized);
                break;
            default:
                url += '&' + encodeURIComponent('parameters[' + k + ']') + '=' + encodeURIComponent(form[k]);
        }
    }
    return url;
}